/**
 * Production-safe Logger Utility
 * Only logs in development mode, silent in production
 */

const isDevelopment = process.env.NODE_ENV !== 'production';

const logger = {
  log: (...args) => {
    if (isDevelopment) console.log(...args);
  },
  info: (...args) => {
    if (isDevelopment) console.info(...args);
  },
  warn: (...args) => {
    if (isDevelopment) console.warn(...args);
  },
  error: (...args) => {
    if (isDevelopment) console.error(...args);
  }
};

export default logger;
